import { createTheme, type ThemeOptions } from '@mui/material/styles';

const fraunces = `'Fraunces Variable', 'Hoefler Text', Georgia, serif`;
const plexSans = `'IBM Plex Sans', system-ui, sans-serif`;
const plexMono = `'IBM Plex Mono', ui-monospace, SFMono-Regular, Menlo, monospace`;

const shared: ThemeOptions = {
  typography: {
    fontFamily: plexSans,
    h1: {
      fontFamily: fraunces,
      fontWeight: 400,
      fontSize: 'clamp(3rem, 8vw, 6rem)',
      lineHeight: 1.05,
      letterSpacing: '-0.02em',
      fontVariationSettings: `'opsz' 144, 'SOFT' 50, 'WONK' 1`,
    },
    h2: {
      fontFamily: fraunces,
      fontWeight: 500,
      fontSize: '2.25rem',
      lineHeight: 1.1,
      letterSpacing: '-0.01em',
      fontVariationSettings: `'opsz' 72, 'SOFT' 50, 'WONK' 1`,
    },
    h3: {
      fontFamily: fraunces,
      fontWeight: 500,
      fontSize: '1.5rem',
      fontVariationSettings: `'opsz' 48, 'SOFT' 50, 'WONK' 1`,
    },
    h4: { fontFamily: plexSans, fontWeight: 600, fontSize: '1.125rem' },
    body1: { fontFamily: plexSans, fontSize: '1rem', lineHeight: 1.6 },
    body2: { fontFamily: plexSans, fontSize: '0.875rem', lineHeight: 1.5 },
    button: { fontFamily: plexSans, fontWeight: 500, textTransform: 'none', letterSpacing: 0 },
    caption: { fontFamily: plexMono, fontSize: '0.75rem' },
  },
  shape: { borderRadius: 2 },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 2 },
        contained: { borderRadius: 0 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: 'var(--bg-elevated)',
          border: '1px solid var(--rule)',
          boxShadow: 'none',
          borderRadius: 2,
        },
      },
    },
    MuiTextField: { defaultProps: { variant: 'outlined' } },
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
  },
};

export const lightTheme = createTheme({
  ...shared,
  palette: {
    mode: 'light',
    background: { default: '#FAF7F2', paper: '#FFFFFF' },
    text: { primary: '#1A1814', secondary: '#5C574E' },
    primary: { main: '#A84D16', dark: '#8F3F10', contrastText: '#FFFFFF' },
    secondary: { main: '#5C574E' },
    error: { main: '#8B2920' },
    divider: '#E8E2D6',
  },
});

export const darkTheme = createTheme({
  ...shared,
  palette: {
    mode: 'dark',
    background: { default: '#0F0D0A', paper: '#1A1714' },
    text: { primary: '#F2EEE6', secondary: '#9B948A' },
    primary: { main: '#E07A38', contrastText: '#0F0D0A' },
    secondary: { main: '#9B948A' },
    error: { main: '#D86954' },
    divider: '#2A2620',
  },
});

export const monoFont = plexMono;
export const displayFont = fraunces;
